const PROGRAMS = new Set(['honours', 'degree', 'masters', 'professional']);

function normalizeDigits(value) {
    return String(value)
        .replace(/[০-৯]/g, (digit) => String.fromCharCode(digit.charCodeAt(0) - 0x09e6 + 48))
        .replace(/\D/g, '');
}

/**
 * @param {string} pathname
 * @param {{ program?: string, examination?: string, year?: string, roll?: string, reg?: string, course?: string }} state
 */
export function buildNationalUniversityResultSharePath(pathname, state) {
    const params = new URLSearchParams();
    if (state.program && PROGRAMS.has(state.program)) params.set('p', state.program);
    if (state.examination) params.set('e', normalizeDigits(state.examination));
    if (state.year) params.set('y', normalizeDigits(state.year));
    if (state.roll) params.set('r', normalizeDigits(state.roll));
    if (state.reg) params.set('reg', normalizeDigits(state.reg));
    if (state.course) params.set('c', normalizeDigits(state.course));
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
}

/**
 * @param {string} origin
 * @param {string} pathname
 * @param {Parameters<typeof buildNationalUniversityResultSharePath>[1]} state
 */
export function buildNationalUniversityResultShareUrl(origin, pathname, state) {
    return `${origin}${buildNationalUniversityResultSharePath(pathname, state)}`;
}

/**
 * @param {URLSearchParams | string} input
 */
export function parseNationalUniversityResultShareParams(input) {
    const params = typeof input === 'string' ? new URLSearchParams(input) : input;
    const program = params.get('p') || '';
    return {
        program: PROGRAMS.has(program) ? program : '',
        examination: normalizeDigits(params.get('e') || ''),
        year: normalizeDigits(params.get('y') || ''),
        roll: normalizeDigits(params.get('r') || ''),
        reg: normalizeDigits(params.get('reg') || ''),
        course: normalizeDigits(params.get('c') || ''),
    };
}

/**
 * @param {{ program?: string, examination?: string, year?: string, reg?: string, course?: string }} state
 */
export function canShareNationalUniversityResult(state) {
    return Boolean(
        state.program
        && state.examination
        && state.year
        && state.reg
        && (state.program !== 'professional' || state.course),
    );
}
